<template>
  <div class="confirm">
    <div class="top">
      <div class="title">{{ data[1].data.GCMC }}</div>
    </div>
    <div class="sub-title">项目信息</div>
    <div class="info">
      <div class="item">
        <div class="label">项目代码</div>
        <div class="text">{{ data[1].data.GCBH }}</div>
      </div>
      <div class="item">
        <div class="label">项目地点</div>
        <div class="text">{{ data[1].data.XZQ }}{{ data[1].data.GCXXDD }}</div>
      </div>
      <div class="item">
        <div class="label">项目性质</div>
        <div class="text">{{ data[1].data.JSXZ }}</div>
      </div>
      <div class="item">
        <div class="label">土地来源</div>
        <div class="text">{{ data[1].data.TDLY }}</div>
      </div>
      <div class="item">
        <div class="label">建筑面积</div>
        <div class="text">{{ data[1].data.JZMJ }}</div>
      </div>
      <div class="item">
        <div class="label">建设单位</div>
        <div class="text">{{ data[1].data.WTDW }}</div>
      </div>
      <div class="item">
        <div class="label">测绘事项</div>
        <div class="text">
          <span v-for="item in data[2].data.CLSX" :key="item.key" style="padding-left: 5px;">
            {{ item.label || item.CLSXName }}
          </span>
        </div>
      </div>
      <div class="item">
        <div class="label">发布对象</div>
        <div class="text">
          <span v-for="item in data[3].data" :key="item" style="line-height: 1.6;">
            {{ item }}<br/>
          </span>
        </div>
      </div>
      <div class="item">
        <div class="label">有效时间</div>
        <div class="text">{{ data[1].data.YXYXQKSSJ + '至' + data[1].data.YXYXQJSSJ }}</div>
      </div>
      <div class="item">
        <div class="label">接单口令</div>
        <div class="text">{{ data[1].data.JDKL }}</div>
      </div>
    </div>
    <div class="sub-title">基本信息</div>
    <div class="info">
      <div class="item">
        <div class="label">联系人</div>
        <div class="text">{{ data[1].data.LXR }}</div>
      </div>
      <div class="item">
        <div class="label">联系电话</div>
        <div class="text">{{ data[1].data.LXDH }}</div>
      </div>
      <div class="item">
        <div class="label">电子邮箱</div>
        <div class="text">{{ data[1].data.DZYX }}</div>
      </div>
    </div>
    <van-dialog v-model="showSuccess" show-cancel-button
      confirm-button-text='查看发布详情' confirm-button-color='#1D84FF'
      cancel-button-text='继续发布'
      @confirm="checkDetail" @cancel="cancelDialog"
    >
      <div class="success-dialog">
        <img src="@/assets/img/opinionPublish/success_icon.png" />
        <div class="text">提交成功</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
// import moduleMixins from '@/mixins/moduleMixins'
import { mapGetters } from 'vuex'
export default {
  components: {},
  // mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      data: [
        {},
        {
          data: {}
        },
        {
          data: []
        },
        {},
      ],
      showSuccess: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters('opinion', ['getOpinionData']),
    // navTitle() {
    //   return '信息确认'
    // },
  },
  methods: {
    checkDetail() {
      let CLSX = []
      this.data[2].data.CLSX.forEach(item => {
        CLSX.push(item.CLSXCode)
      })
      this.$router.push({
        name: 'OpinionPublishDetail',
        query: {
          rid: this.data[6].RID,
          from: 'confirm'
        }
        // params: {
        //   ...this.data[1].data,
        //   USERID: this.data[6].userID,
        //   RID: this.data[6].RID,
        //   // LLCS: "0",
        //   // JID: "",
        //   // CJSJ: "2022年10月10日",
        //   // JSDWUID: "",
        //   // JSCHDW: "", 
        //   // JSSJ: "", 
        //   CLSX: CLSX.join(';'),
        //   // CHDW: "东洋测绘单位;广东南方数码科技股份有限公司;铝金测绘股份有限公司",
        //   // YDMJ: "44",
        //   // BIGCLASS: "立项用地规划许可综合测绘;立项用地规划许可综合测绘;立项用地规划许可综合测绘;立项用地规划许可综合测绘",
        //   FBDX: this.data[3].data.join(';'),
        //   // JSDWLXDH: "",
        //   // JSDWLXR: "",
        //   ZT: "发布中",
        //   from: 'confirm'
        // }
      })
    },
    cancelDialog() {
      console.log('cancelDialog - 继续发布')
      this.$router.go(-4)
      // this.$router.push({
      //   name: 'OpinionPublishProcess'
      // })
    },
  },
  created() {
    // this.data = this.$parent.allData
    this.data = this.getOpinionData()
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.confirm {
  padding-bottom: 100px;
  .top {
    background-color: #fff;
    .title {
      padding: 20px 15px;
      color: #1D84FF;
      position: relative;
    }
  }
  .sub-title {
    padding: 15px;
    color: #333;
  }
  .info {
    background-color: #fff;
    .item {
      padding: 15px 0;
      margin: 0 15px;
      font-size: 14px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      &:last-child {
        border-bottom: 0;
      }
      .label {
        width: 110px;
        color: #666;
        margin-right: 20px;
      }
      .text {
        flex: 1;
        color: #333;
        text-align: right;
      }
    }
  }

  .success-dialog {
    text-align: center;
    padding: 30px 0;
    img {
      width: 60px;
    }
    .text {
      font-size: large;
      font-weight: bold;
      padding-top: 10px;
    }
  }
}
</style>